import { MutableRefObject, useEffect, useState } from 'react';

// rootMargin param determines how much of the component needs to be visible for isIntersecting to be true
const useOnScreen = <T extends Element>(
  ref: MutableRefObject<T>,
  rootMargin = '0px'
): boolean => {
  const [isIntersecting, setIntersecting] = useState<boolean>(false);

  useEffect(() => {
    let localRef: any = null;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIntersecting(entry.isIntersecting);
      },
      {
        rootMargin,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
      localRef = ref.current;
    }

    return () => {
      if (localRef) {
        observer.unobserve(localRef);
      }
    };
  }, [ref, rootMargin]);

  return isIntersecting;
};

export default useOnScreen;
